import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Checkbox,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Grid,
  Header,
  Icon,
  Input,
  Item,
  Menu,
  Modal,
  Table,
  TextArea,
} from "semantic-ui-react";
import MaterialApi from "../../api/material";
import Logo from "../../components/Logo/Logo";

import { useAppDispatch as useDispatch } from "../../hooks/redux";

import { setMaterial } from "../../redux/actions/material";
import { MaterialContractBase } from "../../types/materialContractBase";
import { TaxesTypes } from "../../utils/taxesType";
import { setEmail as setEmailRedux } from "../../redux/actions/admin";

import style from "./style.module.css";
import { downloadFile } from "../../utils/downloadFile";
import { contractTypeSupported } from "../../utils/contractType";
import { useUploadFile } from "../../hooks/useUploadFile";
import { validAliquota } from "../../utils/validAliquota";

export default function MaterialTablePage() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [tipoTributo, setTipoTributo] = useState("");
  const [aliPis, setAliPis] = useState("");
  const [aliConfins, setAliConfins] = useState("");
  const [incoterm, setIncoterm] = useState("");
  const [contract, setContract] = useState<MaterialContractBase>();
  const [modalVisible, setModalVisible] = useState(false);
  const [keepConditionsModalVisible, setKeepConditionsModalVisible] =
    useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [keepConfirmationModal, setKeepConfirmationModal] = useState(false);

  const [tipoTributoModal, setTipoTributoModal] = useState(false);
  const [problemModal, setProblemModal] = useState(false);
  const [problem, setProblem] = useState("");

  const materialContractType = tipoTributo === "Simples"
    ? contractTypeSupported.BR_MATERIALS_SIMPLE
    : contractTypeSupported.BR_MATERIALS;

  const { handleUploadFile, responseOk } = useUploadFile(contract?.id as number, materialContractType, "br");

  const history = useHistory();
  const isSubmitting = useRef(false);
  const updatedContract = async () => {
    if (isSubmitting.current) return;
    isSubmitting.current = true;
    setLoading(true);
    setError("");
    try {
      await MaterialApi.updateContract(
        tipoTributo,
        parseFloat(aliPis),
        parseFloat(aliConfins),
        incoterm
      );
      setConfirmationModal(true);
    } catch (err) {
      console.log(err);
      setError("Problema na hora de salvar");
    } finally {
      setLoading(false);
      isSubmitting.current = false;
    }
  };

  const partialUpdatedContract = async () => {
    setLoading(true);
    setError("");
    try {
      await MaterialApi.partialUpdateContract(tipoTributo, aliPis, aliConfins, incoterm);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };
  const setKeepConditions = async (keepConditions: boolean) => {
    setLoading(true);
    setError("");
    try {
      await MaterialApi.setKeepConditions(keepConditions);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };
  const sendProblem = async () => {
    setLoading(true);
    setError("");
    try {
      await MaterialApi.setProblem(problem);
      setProblemModal(true);
    } catch (err) {
      console.log(err);
      setError("Problema na hora de enviar");
    }
    setLoading(false);
  };
  const getContract = async () => {
    setLoading(true);
    try {
      const contract = await MaterialApi.getContract();

      const mat = contract.materialBases.sort(function (a, b) {
        let x = a.id;
        let y = b.id;
        return x < y ? -1 : x > y ? 1 : 0;
      });
      if (contract.keepConditions === null && contract.round === 0) {
        setKeepConditionsModalVisible(true);
      } else {
        setContract({ ...contract, materialBases: mat });
        if (contract.materialContractUpdate) {
          setAliConfins(contract.materialContractUpdate.confins);
          setAliPis(contract.materialContractUpdate.pis);
          setTipoTributo(contract.materialContractUpdate.taxes);
          setIncoterm(contract.materialContractUpdate.incoterm ?? "");
        }
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const verifyForm = () => {
    if (tipoTributo === "" || aliPis === "" || aliConfins === "" || incoterm === "") {
      return false;
    }
    return true;
  };

  const execDownloadFile = async () => {
		try {
      await partialUpdatedContract();
      if (contract?.id) {
        downloadFile(contract.id.toString(), materialContractType);
      }
		} catch (err) {
      console.log(err);
      setError("Problema ao exportar");
		}
	}

  useEffect(() => {
    getContract();
  }, []);

  useEffect(() => {
    if (responseOk) {      
      getContract();
    }
  }, [responseOk]);


  const changeDiscontinued = async (id: number, discontinued: boolean) => {
    try {
      await MaterialApi.setDiscontinued(id, discontinued);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div className={style.container}>
      <Modal
        onClose={() => {
          setProblemModal(false);
          dispatch(setEmailRedux(null));
          history.replace(`/loginMaterial/${contract?.id}`);
        }}
        onOpen={() => setProblemModal(true)}
        open={problemModal}
      >
        <Modal.Header>Confirmação</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              Seu problema foi enviado com sucesso, logo entraremos em contato
            </Header>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content="OK"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setProblemModal(false);
              dispatch(setEmailRedux(null));
              history.replace(`/loginMaterial/${contract?.id}`);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>
      <Modal
        onClose={() => {
          setTipoTributoModal(false);
        }}
        onOpen={() => setTipoTributoModal(true)}
        open={tipoTributoModal}
      >
        <Modal.Header>Aviso</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              Preencha o tipo de tributação antes de ajustar os itens
            </Header>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content="OK"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setTipoTributoModal(false);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>

      <Modal
        onOpen={() => setKeepConditionsModalVisible(true)}
        open={keepConditionsModalVisible}
      >
        <Modal.Header>Aviso</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              Podemos manter as condições do contrato por mais um ano?
            </Header>
            <Grid.Column>
              <Grid.Row textAlign="left">
                <label>Tipo de tributação *: </label>
                <br />

                <Dropdown
                  placeholder=""
                  search
                  selection
                  value={tipoTributo}
                  onChange={(_, { value }) => setTipoTributo(value!.toString())}
                  options={TaxesTypes.map((it) => {
                    return { key: it, text: it, value: it };
                  })}
                  onBlur={() => {
                    partialUpdatedContract();
                  }}
                />
              </Grid.Row>
              <br />
            </Grid.Column>
            <p>Obs: Renegociação poderá abrir um novo leilão.</p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            disabled={!tipoTributo}
            loading={loading}
            content="Verificar Condições"
            // labelPosition="right"
            onClick={async () => {
              partialUpdatedContract();
              await setKeepConditions(true);
              await getContract();
              await setKeepConditionsModalVisible(false);
            }}
            negative
          />
          <Button
            disabled={!tipoTributo}
            loading={loading}
            content="Manter"
            // labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setKeepConfirmationModal(true);
              setKeepConditionsModalVisible(false);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>
      <Modal
        onOpen={() => setKeepConfirmationModal(true)}
        open={keepConfirmationModal}
      >
        <Modal.Header>Aviso</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>Confirma que deseja manter as condições atuais?</Header>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            loading={loading}
            content="Cancelar"
            // labelPosition="right"
            onClick={async () => {
              setKeepConfirmationModal(false);
              setKeepConditionsModalVisible(true);
            }}
            negative
          />
          <Button
            loading={loading}
            content="Sim"
            // labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setKeepConditions(true);
              updatedContract();
              setKeepConfirmationModal(false);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>

      <Modal
        onClose={() => {
          setConfirmationModal(false);
          dispatch(setEmailRedux(null));
          history.replace(`/loginMaterial/${contract?.id}`);
        }}
        onOpen={() => setConfirmationModal(true)}
        open={confirmationModal}
      >
        <Modal.Header>Confirmação</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              Seu contrato foi enviado com sucesso, entraremos em contato
              finalizando a negociação ou com uma contraproposta
            </Header>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content="OK"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setConfirmationModal(false);
              dispatch(setEmailRedux(null));
              history.replace(`/loginMaterial/${contract?.id}`);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>
      <Modal
        onClose={() => setModalVisible(false)}
        onOpen={() => setModalVisible(true)}
        open={modalVisible}
      >
        <Modal.Header>Problema</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>Estou com um problema</Header>
            <p>Descreva o seu problema</p>
          </Modal.Description>
          <TextArea
            cols="100"
            placeholder="Nos conte mais sobre seu problema"
            value={problem}
            onChange={(e, data) => {
              setProblem(data.value!.toString());
            }}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button color="black" onClick={() => setModalVisible(false)}>
            Cancelar
          </Button>
          <Button
            content="Enviar e finalizar negociação"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setModalVisible(false);
              sendProblem();
            }}
            positive
          />
        </Modal.Actions>
      </Modal>
      <Logo />
      <Button
        floated="right"
        loading={loading}
        color="red"
        onClick={() => setModalVisible(true)}
      >
        Estou com um Problema
      </Button>
      {/* <Header as="h1">Smart Contract</Header> */}

      <Grid columns={6} stackable>
        <Grid.Column>
          <Item.Group>
            <Item>
              <Item.Content>
                <Item.Header>Contrato</Item.Header>
                <Item.Meta>
                  <label>Numero:</label>
                  <span>{contract?.contractId}</span>
                  <br />
                  <label>Fornecedor:</label>
                  <span>{contract?.supplierName}</span>
                  <br />
                  <label>Moeda:</label>
                  <span>{contract?.currency}</span>
                  <br />
                  <label>CNPJ:</label>
                  <span>{contract?.fiscalCode}</span>
                  <br />
                  <label>Centro:</label>
                  <span>{contract?.company}</span>
                </Item.Meta>
                <Item.Description>{}</Item.Description>
              </Item.Content>
            </Item>
          </Item.Group>
        </Grid.Column>

        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>Alícota PIS % *: </label>
            <br />
            <Input
              value={aliPis}
              onChange={(e) => {
                if (validAliquota(e.target.value.replace(",", "."))) {
                  setAliPis(e.target.value.replace(",", "."));
                }
              }}
              onBlur={() => {
                if (isNaN(parseFloat(aliPis))) {
                  setAliPis("");
                } else {
                  setAliPis(parseFloat(aliPis).toFixed(2));
                }
                partialUpdatedContract();
              }}
              placeholder="Alícota PIS"
            />
          </Grid.Row>
          <br />
        </Grid.Column>
        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>Alícota COFINS % *: </label>
            <br />
            <Input
              value={aliConfins}
              onChange={(e) => {
                if (validAliquota(e.target.value.replace(",", "."))) {
                  setAliConfins(e.target.value.replace(",", "."));
                }
              }}
              onBlur={() => {
                if (isNaN(parseFloat(aliConfins))) {
                  setAliConfins("");
                } else {
                  setAliConfins(parseFloat(aliConfins).toFixed(2));
                }
                partialUpdatedContract();
              }}
              placeholder="Alícota COFINS"
            />
          </Grid.Row>
          <br />
        </Grid.Column>
        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>INCOTERM: *</label>
            <br />
            <Input
              value={incoterm}
              onChange={(e) => setIncoterm(e.target.value.toUpperCase())}
              onBlur={() => partialUpdatedContract()}
              placeholder="Ex: CIF, FOB"
            />
          </Grid.Row>
          <br />
        </Grid.Column>
        <Grid.Column>
          <text>Preencha todos os campos *</text>
          <br />

          {contract?.keepConditions === false ? (
            <Button
              loading={loading}
              primary
              disabled={loading || !verifyForm()}
              onClick={updatedContract}
            >
              Enviar negociação
            </Button>
          ) : (
            <>
              <Button
                loading={loading}
                color="red"
                disabled={loading}
                onClick={async () => {
                  await setKeepConditions(false);
                  await getContract();
                }}
              >
                Renegociar
              </Button>
              <Button loading={loading} disabled={loading} color="green" onClick={updatedContract}>
                Aceitar
              </Button>
              <br />
              <text>Obs: Renegociação poderá iniciar um novo leilão.</text>
            </>
          )}
          <br />
          <text className={style.error}>{error}</text>
        </Grid.Column>        
      </Grid>
      <Grid.Column style={{display: "flex", justifyContent: "right"}}>          
        <Dropdown text="Negociação em massa" className="selection">
          <DropdownMenu>
            <DropdownItem text="Exportar Modelo" onClick={execDownloadFile}/>
            <DropdownItem text="Importar Excel" onClick={handleUploadFile}/>
          </DropdownMenu>
        </Dropdown>
      </Grid.Column>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Código</Table.HeaderCell>
            <Table.HeaderCell>
              Preço Liquido Atual
              <br />
              (Cálculo Ambev)
            </Table.HeaderCell>
            {tipoTributo !== "Simples" && (
              <Table.HeaderCell>Preço Líquido Proposto</Table.HeaderCell>
            )}
            <Table.HeaderCell>Preço Bruto Proposto</Table.HeaderCell>
            <Table.HeaderCell>Reajuste Percentual</Table.HeaderCell>
            <Table.HeaderCell>Descrição</Table.HeaderCell>
            <Table.HeaderCell>Prazo de Entrega</Table.HeaderCell>
            {contract?.keepConditions === false ? (
              <>
                <Table.HeaderCell>Reajustar (Obrigatório)</Table.HeaderCell>
                <Table.HeaderCell>Material Descontinuado</Table.HeaderCell>
              </>
            ) : null}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {contract?.materialBases.map((material) => {
            return (
              <Table.Row key={material.material}>
                <Table.Cell>{material.material}</Table.Cell>
                <Table.Cell>
                  {parseFloat(material.price).toFixed(2) +
                    " " +
                    contract.currency}
                </Table.Cell>
                {tipoTributo !== "Simples" && (
                  <Table.Cell>
                    {material.materialUpdate?.netPrice
                      ? material.materialUpdate.netPrice + " " + contract.currency
                      : ""}
                  </Table.Cell>
                )}
                <Table.Cell>
                  {material.negotiationPrice
                    ? material.negotiationPrice + " " + contract.currency
                    : ""}
                </Table.Cell>
                <Table.Cell>{material.raisePercentage + "%"}</Table.Cell>
                <Table.Cell>{material.longDescription}</Table.Cell>
                <Table.Cell>{material.materialUpdate?.leadTimeDays ?? ""}</Table.Cell>
                {contract?.keepConditions === false ? (
                  <>
                    <Table.Cell>
                      <Button
                        animated="vertical"
                        color={material.updated ? "yellow" : "grey"}
                        onClick={async () => {
                          if (tipoTributo && incoterm) {
                            await partialUpdatedContract();
                            dispatch(setMaterial(material));
                            history.push({
                              pathname: `/materialContract/material`,
                              state: tipoTributo,
                            });
                          } else {
                            setTipoTributoModal(true);
                          }
                        }}
                        disabled={material.discontinued}
                      >
                        <Button.Content visible>
                          {material.updated ? "Preço proposto" : "Reajustar"}
                        </Button.Content>
                        <Button.Content hidden>
                          <Icon name="edit" />
                        </Button.Content>
                      </Button>
                    </Table.Cell>
                    <Table.Cell>
                      <Checkbox
                        checked={material.discontinued}
                        onChange={(e, data) => {
                          let mat = contract.materialBases.filter(
                            (it) => it.id !== material.id
                          );

                          mat.push({
                            ...material,
                            discontinued: data.checked!,
                          });
                          mat = mat.sort(function (a, b) {
                            let x = a.id;
                            let y = b.id;
                            return x < y ? -1 : x > y ? 1 : 0;
                          });

                          setContract({ ...contract, materialBases: mat });
                          changeDiscontinued(material.id, data.checked!);
                        }}
                        label="Descontinuado"
                      />
                    </Table.Cell>
                  </>
                ) : null}
              </Table.Row>
            );
          })}
        </Table.Body>

        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan={(tipoTributo === "Simples" ? 6 : 7) + (contract?.keepConditions === false ? 2 : 0)}>
              <Menu floated="right" pagination>
                <Menu.Item
                  icon
                  onClick={() => {
                    //previus
                  }}
                >
                  <Icon name="chevron left" />
                </Menu.Item>
                <Menu.Item>{/* {page} of {totalPages} */}1 of 1</Menu.Item>
                <Menu.Item
                  icon
                  onClick={() => {
                    //onNextClick
                  }}
                >
                  <Icon name="chevron right" />
                </Menu.Item>
              </Menu>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </div>
  );
}
